import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
const RegistrationHeroSection = ({ heading, subheading, buttonText, buttonCustomClasses, url }) => {

  const brandSlug = window.gon.current_brand ? window.gon.current_brand : 'shipsticks';
  
  return (
    <div className="relative text-center px-7 py-14 pt-16 md:py-12 lg:py-14
      md:px-16 lg:px-36 xl:px-44 2xl:px-60">
      <div className="max-w-7xl mx-auto">
        <h1 className="
          text-[2.5rem] lg:text-[3.25rem] leading-[3.125rem] lg:leading-[3.875rem]
          text-white font-bold mb-6 break-words
        ">
          {parse(heading)}
        </h1>
        {subheading && (<p className="font-semibold text-white text-[1.375rem] leading-[1.875rem] mb-7">
          {parse(subheading)}
        </p>)}
        <button
          onClick={(e) => {
            e.preventDefault();
            const id = url?.split('#')[1];
            const el = id && document.getElementById(id);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
            }
          }}
          className={`
            mt-4 px-6 py-3 text-white font-semibold text-lg rounded-md bg-${brandSlug}
            ${buttonCustomClasses}
          `}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

RegistrationHeroSection.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subheading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonText: PropTypes.string,
  buttonCustomClasses: PropTypes.string,
  url: PropTypes.string,
};

export default RegistrationHeroSection;